<template>
    <div class="minidiv">
    
        <div class="flex-parent text-center p-1">
            <p class="flex-child">{{ sn + ((page - 1) * interval) }}</p>
            <p class="flex-child"><b-link :to="{ name : 'editambassadors', params : { email : ambassador.email }}">{{ ambassador.name }}</b-link></p>
            <!-- <p class="flex-child">{{ ambassador.name }}</p> -->
            <p class="flex-child">{{ ambassador.email }}</p>
            <p class="flex-child">{{ ambassador.wphone }}</p>
            <p class="flex-child">{{ ambassador.refcode }}</p>
            <p class="flex-child">{{ ambassador.location }}</p>
            <p class="flex-child">{{ ambassador.totalearnings }}</p>
            <p class="flex-child">{{ ambassador.totalpayouts }}</p>
            <p class="flex-child">{{ ambassador.totalsignups }}</p>
            <p class="flex-child">{{ ambassador.totalupgraded }}</p>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: ["ambassador", 'sn', 'page', 'interval'],
    data() {
        return {
            overallscore: 0
        };
    },
    created() {

    },
    methods: {
    

    },
    computed: {
        ...mapState({
            allinstitutions: state => state.admin.listinstitutions,
            details: state => state.loginmaster.details,
        })
    }
};
</script>

<style scoped>
.minidiv {
    border-radius: 10px 10px;
    background-color: white;
    overflow-x: scroll
    /* padding: 5px; */
}

.rins {
    font-size: 0.75rem;
}

.lowscore {
    color: red;
}

.highscore {
    color: #00377b;
}

.totsco {
    color: #00377b;
    font-weight: bolder;
}

.brel {
    text-decoration: none;
    color: black;
}

.link-sol {
    text-decoration: none;
    color: #00984a;
}

.flex-parent {
    display: flex;
    flex-flow: row nowrap;
    overflow: auto;
    scrollbar-width: thin;
    /* height: 35px; */
}

.flex-child {
    width: 10%;
    overflow: auto;
    scrollbar-width: thin;
}

@media screen and (max-width: 768px) {
    .flex-child {
        font-size: 0.6rem
    }
    .link-sol {
        font-size: 0.7rem
    }
    .list-button {
        width: contain;
        font-size: 0.6rem;
        padding: 3px;
    }
}
</style>
